<div class="wiz-box">
  <div class="heading">{{'wizard.step-4.title' | translate}}</div>

  <div class="wiz-content">
    <p class="my-2 mb-3 text-muted">
      {{'wizard.step-4.p-1' | translate}}
    </p>
    <div class="mw-380">
      <div [formGroup]="suppliersGroup">
        <ng-container *ngFor="let supplier of suppliersGroup.controls | keyvalue: order; trackBy: trackById; let last = last; let index = index">
          <form-row-input
            [inputDisabled]="supplierMap.get(+supplier.key)?.externalId === 'henryschein'"
            [appendBtnIcon]="supplierMap.get(+supplier.key)?.id > 0 && supplierMap.get(+supplier.key)?.deletable && (!last || supplier.key.includes('new')) && !last ? 'fa-times-circle': null"
            (onAppendBtnEvent)="last ? null : deleteDialog(supplier.key)"
            formControlName="{{supplier.key}}"
            (modelChange)="addItem(this.suppliersGroup)"
            (focusout)="save(supplier.key.toString())"
            placeholder="wizard.step-4.next-supplier"
            [disallowTabNavToBtn]="true"
          ></form-row-input>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-3/list"><i class="fas fa-chevron-left"></i><span>{{'wizard.step-4.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-5/" (click)="setHighestLastStepCompleted.emit(3)"><span>{{'wizard.step-4.btn-continue' | translate}}</span><i class="fas fa-chevron-right"></i></button>
  </div>
</div>
